import { observer } from "mobx-react-lite"

import { Card } from "@/components/card"
import { ClFarmStore } from "@/domains/cl-farm/cl-farm-store"
import { BodyLg } from "@/domains/design/components/body-lg"
import { BodyXs } from "@/domains/design/components/body-xs"
import { cn, prettifyCurrency, prettifyNumber } from "@/domains/library"
import { useGovernanceTokenPrice } from "@/hooks/use-governance-token-price"

import { ClFarmsBreakdownChart } from "./cl-farms-breakdown-chart"

export const ClFarmBreakdownStats = observer(
  ({ clFarm, className }: { clFarm: ClFarmStore | null | undefined; className?: string }) => {
    const governancePrice = useGovernanceTokenPrice()

    if (!clFarm || !clFarm?.connectedGauge) {
      return null
    }

    const tvlText = prettifyCurrency(clFarm.tvlUsd)
    const emissions = (((clFarm.tvlUsd * (clFarm.apr / 100)) / 365) * 7) / Number(governancePrice)

    return (
      <Card.Container className={cn("p-4 lg:p-4", className)}>
        <div>
          <ClFarmsBreakdownChart clFarm={clFarm} />
        </div>
        <div className="grid grid-cols-3">
          <div>
            <Stat title="TVL" value={tvlText} />
          </div>
          <div>
            <Stat title="APR" value={clFarm.displayApr} />
          </div>
          <div>
            <Stat title="EMISSIONS" value={prettifyNumber(emissions)} />
          </div>
        </div>
      </Card.Container>
    )
  },
)

const Stat = ({ title, value }: { title: string; value: string }) => {
  return (
    <div className="space-y-1 text-center">
      <BodyXs className="text-t300">{title}</BodyXs>
      <BodyLg className="text-t100">{value}</BodyLg>
    </div>
  )
}
